module.exports = __webpack_public_path__ + "static/media/Icon - residents.11defe2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - residents.svg
// module id = 160
// module chunks = 0